export const CARE_COMMON_MODALS_NAMES = {
  mobileServiceRedirectModal: 'mobileServiceRedirectModal',
}
